import {
    MANAGE_PREVIOUS_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID_INTERNAL,
    RESET_PREVIOUS_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID_INTERNAL,
} from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface IncomeAttributeInternalState extends BaseAsyncReducerState {
    snapshotId: number,
}

// Define an initial state value
const initialState: IncomeAttributeInternalState = {
    success: false,
    message: "",
    loading: false,
    error: false,
    data: [],
    snapshotId: 0,
}

function getPreviousIncomeAttributesInternalReducer(state = initialState, action: AppAction | LocalAction) {
    if (action.type === RESET_PREVIOUS_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID_INTERNAL) {
        return { ...initialState };
    } else {
        return defaultAsyncReducer(state, action as AppAction, MANAGE_PREVIOUS_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID_INTERNAL);
    }
}

export default getPreviousIncomeAttributesInternalReducer;